import pdfPageTitle from './PDFPageTitle';

export default ({ title, description, colorClass = 'print.primary.7', image, model }) => ({
    pageTitle: pdfPageTitle({ title, description, colorClass }),
    demogImage: {
        position: 'content',
        src: image.src,
        y: 'h-11-1/4',
        h: image.height
    },
    regionBlurb: {
        position: 'col-2',
        y: 'h-7-1/2',
        blurbTitle: {
            text: `${model.parent.urbanRuralLabel}`,
            font: { weight: 'bold', size: 'base', colour: 'print.strong' },
        },
        blurb: {
            mt: 10,
            text: `The ${model.parent.localName} LGA is in the ${model.parent.urbanRuralLabel} category. This report contains comparisons among LGA’s that are in the same category. LGA’s are categorized based on multiple criteria: population density, distance from urban/rural centres, local knowledge about the area, travel patterns of populations seeking services, and place of work and commuting behaviours.`
        }
    }
});
